export default {
  atoms: {
    adSlot: {
      adLabel: 'Publicité'
    },
    accountToggleField: {
      leftLabel: {
        "default": '_TODO: No'
      },
      rightLabel: {
        "default": '_TODO: Yes'
      }
    },
    authSupportCopy: {
      copy: 'Besoin d\'aide supplémentaire? Nous pouvons aider.',
      action: 'Envoyez-nous un email à'
    },
    premiumIdentifier: {
      iconText: 'Premium'
    },
    recaptchaCopy: {
      agreeLineOne: 'Ce site est protégé par reCAPTCHA et Google',
      agreeLineTwo: 'Politique de confidentialité',
      agreeLineThree: 'et',
      agreeLineFour: 'Conditions de service',
      agreeLineFive: 's\'appliquent.',
      ariaLabel: {
        privacy: 'politique de confidentialité',
        terms: 'conditions de service'
      }
    },
    termsAndConditions: {
      agreeLineOne: 'En créant un compte, vous acceptez le',
      agreeLineTwo: 'termes',
      agreeLineThree: 'et',
      agreeLineFour: 'politique de confidentialité',
      agreeLineFive: 'de Immediate Media Company Limited. Vous pouvez vous désinscrire des e-mails à tout moment.',
      ariaLabel: {
        privacy: 'politique de confidentialité',
        terms: 'termes et conditions'
      }
    },
    time: {
      conjunction: 'et',
      // v4 plural
      formatTimeHours_one: '{{hours}} h',
      formatTimeHours_few: '{{hours}} h',
      formatTimeHours_many: '{{hours}} h',
      formatTimeHours_other: '{{hours}} h',
      // v3 plural
      formatTimeHours: '{{hours}} h',
      formatTimeHours_plural: '{{hours}} h',
      formatTimeHours_0: '{{hours}} h',
      formatTimeHours_1: '{{hours}} h',
      formatTimeHours_2: '{{hours}} h',
      // v4 plural
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} min',
      // v3 plural
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    instagramEmbed: {
      viewPostOnInstagram: 'Voir la publication sur Instagram'
    }
  },
  hoc: {
    withAccessibleMenu: {
      backButtonText: 'Menu principal'
    }
  },
  molecules: {
    accountNav: {
      defaultLabel: 'Mon compte',
      registerText: 'S\'inscrire',
      signInText: 'Se connecter',
      ariaLabel: {
        account: 'Compte'
      }
    },
    adBanner: {
      ariaLabel: {
        dismissText: 'Fermer la bannière publicitaire'
      }
    },
    ageVerificationModal: {
      title: 'Vérification de l\'âge',
      intro: 'Ce site contient du contenu destiné uniquement aux adultes',
      deny: 'Je n\'ai pas plus de {{ageLimit}}',
      confirm: 'J\'ai plus de {{ageLimit}}',
      moreInfo: 'Plus d\'informations',
      remember: 'Se souvenir de moi.'
    },
    authDropDown: {
      registerText: 'S\'inscrire',
      signInText: 'Se connecter'
    },
    batchedGrid: {
      showingItemsText: 'Affichage des éléments 1 à {{nItemsShown}} sur {{nItems}}',
      viewMoreButtonText: 'Voir plus',
      showMoreButtonsText: 'Montrer plus'
    },
    cookAndPrepTime: {
      sr: {
        timeRange: 'Temps de préparation et de cuisson'
      },
      timeRange: {
        cook: 'Cuisson :',
        prep: 'Préparation :',
        total: 'Temps total'
      }
    },
    eyebrowNav: {
      ariaLabel: {
        quickLinks: 'Liens rapides'
      }
    },
    formAutoComplete: {
      ariaLabel: {
        noResult: 'Aucun résultat',
        search: 'Recherche'
      }
    },
    formImageUpload: {
      button: {
        loadPrompt: 'Appuyez ou cliquez pour ajouter une photo',
        loadPromptRequired: 'requis',
        loadPromptOptional: 'optionnel',
        ownImage: '*Veuillez vous assurer que c\'est votre propre image',
        remove: 'Supprimer',
        rotateLeft: 'Tourner à gauche',
        rotateRight: 'Tourner à droite',
        save: 'Enregistrer'
      },
      error: {
        maxFileSize: 'La taille du fichier est trop grande, veuillez télécharger une image de moins de {{maxFileSize}}MB',
        minHeight: 'L\'image ne répond pas à l\'exigence de hauteur minimale de {{minDimensions}}px',
        minWidth: 'L\'image ne répond pas à l\'exigence de largeur minimale de {{minDimensions}}px'
      }
    },
    formMultiSelect: {
      ariaLabel: {
        formInput: 'Filtrer {{label}}'
      },
      filterOptions: {
        noResult: 'Aucun résultat',
        selectAllLabel: 'Tout sélectionner',
        inputPlaceholderSelect: 'Sélectionner...',
        inputPlaceholderSelected: 'sélectionné'
      },
      sr: {
        optionsButton: 'Basculer l\'affichage des options'
      }
    },
    formSortableInputs: {
      ariaLabel: {
        deleteInput: 'Supprimer',
        grab: 'Saisir pour déplacer l\'entrée'
      }
    },
    formSubmitButton: {
      button: {
        savedText: 'Enregistré',
        savingText: 'Enregistrement'
      }
    },
    gallery: {
      ariaLabel: {
        fullScreen: 'ouvrir la galerie en plein écran'
      },
      imgCountText: '{{slideCount}} sur {{images}}'
    },
    glossaryNav: {
      ariaLabel: {
        nav: 'glossaire'
      }
    },
    heightClamper: {
      button: {
        expandTextMore: 'Montrer plus',
        expandTextLess: 'Montrer moins'
      }
    },
    ingredientsList: {
      heading: 'Ingrédients'
    },
    inlineGallery: {
      imageCount: '{{imageCount}} sur {{totalImages}}'
    },
    keyValueBlocks: {
      keyHeader: 'Clé',
      prefixHeader: 'Surligner',
      valueHeader: 'Valeur'
    },
    lightBox: {
      ariaLabel: {
        close: 'fermer'
      }
    },
    loadingIcon: {
      sr: {
        icon: 'Chargement'
      }
    },
    loadingState: {
      "default": {
        heading: 'Un moment s\'il vous plaît...'
      },
      createAccount: {
        heading: 'Accrochez-vous!',
        subHeading: 'Nous configurons votre compte'
      },
      logout: {
        heading: 'Un moment s\'il vous plaît...',
        subHeading: 'Juste en train de vous déconnecter.'
      }
    },
    methodList: {
      methodLabel: 'Préparation',
      counterPrefix: 'ÉTAPE'
    },
    modal: {
      ariaLabel: {
        close: 'Fermer le modal'
      }
    },
    numericPaginator: {
      icon: {
        prev: 'Préc',
        next: 'Suiv'
      },
      sr: {
        icon: 'Page',
        nav: 'Vous êtes actuellement sur la page {{page}}'
      }
    },
    passwordCriteria: {
      ariaLabel: {
        notSatisfied: 'n\'est pas satisfait',
        satisfied: 'est satisfait'
      },
      config: {
        bothCase: 'Lettres minuscules et majuscules',
        lowerCase: 'Lettres minuscules',
        // v4 plural
        minLength_one: 'Au moins {{minLength}} caractère',
        minLength_few: 'Au moins {{minLength}} caractères',
        minLength_many: 'Au moins {{minLength}} caractères',
        minLength_other: 'Au moins {{minLength}} caractères',
        // v3 plural
        minLength: 'Au moins {{minLength}} caractère',
        minLength_plural: 'Au moins {{minLength}} caractères',
        minLength_0: 'Au moins {{minLength}} caractère',
        minLength_1: 'Au moins {{minLength}} caractères',
        minLength_2: 'Au moins {{minLength}} caractères',
        requireDigit: 'Un nombre (c.-à-d. 0–9)',
        symbol: 'Un symbole (par exemple !, ?, @)',
        upperCase: 'Lettres majuscules'
      },
      passwordContain: {
        text: 'Votre mot de passe doit contenir'
      },
      sr: {
        passwordContain: 'Votre mot de passe doit contenir :'
      }
    },
    passwordInput: {
      buttonText: {
        hide: 'CACHER',
        show: 'MONTRER'
      },
      formLabels: {
        currentPassword: '_TODO: Current password',
        newPassword: '_TODO: New password',
        password: 'Mot de passe'
      },
      placeholder: 'Entrez votre mot de passe',
      sr: {
        strength: 'La force du mot de passe est {{passwordStrength}}',
        visibility: {
          hidden: 'Mot de passe caché',
          shown: 'Mot de passe montré'
        }
      }
    },
    plantOverview: {
      averageYield: 'Rendement moyen :',
      depth: 'Profondeur :',
      size: 'Taille de la plante :',
      spacing: 'Espacement :',
      spacingApart: '{{spacingApart}} à part',
      spacingBetween: '{{spacingBetweenRows}} entre les rangées'
    },
    popupToggleButton: {
      ariaLabel: {
        toggle: 'Basculer {{popup}} popup'
      }
    },
    postContentStream: {
      ariaMessage: {
        itemsAdded: 'Nouveaux éléments ajoutés à',
        singleItemAdded: 'Nouvel élément ajouté à'
      }
    },
    postTeaser: {
      readMore: 'Lire la suite',
      publishDate: 'Publié : {{published}}'
    },
    rate: {
      sr: {
        legend: 'Quelle est votre évaluation en étoiles sur {{bestRating}}?',
        outOf: 'sur',
        // v4 plural
        star_one: 'étoile',
        star_few: 'étoiles',
        star_many: 'étoiles',
        star_other: 'étoiles',
        // v3 plural
        star: 'étoile',
        star_plural: 'étoiles',
        star_0: 'étoile',
        star_1: 'étoiles',
        star_2: 'étoiles'
      }
    },
    rating: {
      ariaLabel: {
        rating: 'évaluation'
      },
      countText: '{{count}} {{label}}',
      types: {
        // v4 plural
        rating_one: 'évaluation',
        rating_few: 'évaluations',
        rating_many: 'évaluations',
        rating_other: 'évaluations',
        // v3 plural
        rating: 'évaluation',
        rating_plural: 'évaluations',
        rating_0: 'évaluation',
        rating_1: 'évaluations',
        rating_2: 'évaluations',
        // v4 plural
        review_one: 'critique',
        review_few: 'critiques',
        review_many: 'critiques',
        review_other: 'critiques',
        // v3 plural
        review: 'critique',
        review_plural: 'critiques',
        review_0: 'critique',
        review_1: 'critiques',
        review_2: 'critiques'
      },
      inlineRateText: 'Évaluer',
      skeletonRateText: 'Évaluer'
    },
    ratingsCriteria: {
      overallLabel: 'Évaluation globale'
    },
    searchForm: {
      ariaLabel: {
        performSearch: 'Effectuer une recherche',
        resetButton: 'Réinitialiser l\'entrée'
      }
    },
    sideBarNav: {
      ariaLabel: {
        settings: 'Mes paramètres',
        verticalNav: 'Côté'
      }
    },
    socialShare: {
      sr: {
        iconEmail: 'Envoyer à un ami',
        iconShare: 'Partager sur {{platform}}'
      }
    },
    socialSignInButton: {
      signUpWithButtonText: 'S\'inscrire avec',
      continueWithButtonText: 'Continuer avec'
    },
    tableClamper: {
      collapseButtonText: 'Montrer moins',
      expandButtonText: 'Montrer plus'
    },
    truncatedIcons: {
      tooltipLabel: 'plus'
    },
    accountDetails: {
      copy: {
        lineOne: '_TODO: We need your first name and last name so we can personalise correspondence.',
        lineTwo: '_TODO: Your screen name is public and may be seen by other members if you post on our site.'
      },
      firstNameLabel: '_TODO: First name',
      lastNameLabel: '_TODO: Last name',
      screenNameLabel: '_TODO: Screen name (public)',
      screenNamePlaceholder: '_TODO: Screen name',
      emailLabel: '_TODO: Email address',
      formLegend: '_TODO: Account details form',
      inputErrorMessages: {
        firstName: {
          tooLong: '_TODO: First name must be no longer than 100 characters'
        },
        lastName: {
          tooLong: '_TODO: Last name must be no longer than 100 characters'
        },
        email: {
          tooLong: '_TODO: Email address must be no longer than 100 characters',
          typeMismatch: '_TODO: Please enter a valid email address',
          valueMissing: '_TODO: Please enter an email address'
        },
        screenName: {
          tooLong: '_TODO: Screen name must be no longer than 100 characters',
          valueMissing: '_TODO: Please enter a screen name'
        }
      },
      saveButtonText: {
        "default": '_TODO: Save changes',
        saving: '_TODO: Saving',
        saved: '_TODO: Saved'
      }
    },
    accountManagement: {
      changePassword: {
        readOnly: {
          copy: '_TODO: This information is hidden',
          label: '_TODO: Password'
        },
        edit: {
          cancelButtonText: '_TODO: Cancel',
          currentPasswordLabel: '_TODO: Current password',
          label: '_TODO: Change password',
          newPasswordLabel: '_TODO: New password',
          submitButtonText: '_TODO: Save changes'
        }
      },
      deleteAccount: {
        label: '_TODO: Delete account',
        copy: '_TODO: To request permanent deletion of your account please click',
        copyLink: '_TODO: here'
      },
      formLegend: '_TODO: Account management form'
    }
  },
  organisms: {
    emailSentConfirmation: {
      accountVerificationHeading: 'Nous avons envoyé un email de vérification à ',
      passwordResetHeading: 'Si vous avez un compte, vous recevrez un email pour réinitialiser votre mot de passe.',
      resendEmailCopy: 'Vous n\'avez pas reçu l\'email? ',
      bodyCopy: 'Veuillez vérifier tous les dossiers de votre boîte de réception, y compris le spam.',
      resendEmailButton: 'Cliquez pour renvoyer',
      supportEmailSubject: 'J\'ai besoin d\'aide pour vérifier mon compte.'
    },
    cardBuilder: {
      ariaLabel: {
        mediaImage: 'Voir {{title}}'
      },
      offerCodeText: 'utilisez le code : {{offerCode}}'
    },
    cardCarouselSection: {
      errorMessage: 'Oh non, quelque chose a mal tourné lors du chargement des données. Veuillez essayer une autre option.',
      formLabel: 'Options',
      infoMessage: 'Désolé, il n\'y a pas de données disponibles.',
      slidesToShowItems: 'Affichage des éléments {{currentSlide}} à {{nextSlides}} sur {{allSlides}}',
      slidesToShowItem: 'Affichage de l\'élément {{currentSlide}} sur {{allSlides}}'
    },
    carousel: {
      sr: {
        iconStack: 'élément {{direction}}',
        paging: 'Page {{pageNumber}}'
      }
    },
    changeEmailConfirmation: {
      bodyCopy: '_TODO: For your security, please enter your password to continue',
      submitButton: '_TODO: Go to my account'
    },
    resetPasswordForm: {
      bodyCopy: '_TODO: Enter a password for',
      submitButton: 'Soumettre le mot de passe'
    },
    collection: {
      ariaLabel: {
        edit: 'Modifier',
        registerButton: 'S\'inscrire',
        share: 'Partager',
        signinButton: 'Se connecter'
      },
      author: '{{author}}',
      signinLinkText: 'Se connecter',
      signInLinkTitle: 'Se connecter',
      signInPromptLineOne: 'Est-ce votre collection?',
      signInPromptLineTwo: 'pour modifier'
    },
    dynamicAccordian: {
      // v4 plural
      nextLabel_one: 'Afficher le prochain élément {{count}}',
      nextLabel_few: 'Afficher les prochains éléments {{count}}',
      nextLabel_many: 'Afficher les prochains éléments {{count}}',
      nextLabel_other: 'Afficher les prochains éléments {{count}}',
      // v3 plural
      nextLabel: 'Afficher le prochain élément {{count}}',
      nextLabel_plural: 'Afficher les prochains éléments {{count}}',
      nextLabel_0: 'Afficher le prochain élément {{count}}',
      nextLabel_1: 'Afficher les prochains éléments {{count}}',
      nextLabel_2: 'Afficher les prochains éléments {{count}}',
      // v4 plural
      previousLabel_one: 'Afficher l\'élément précédent {{count}}',
      previousLabel_few: 'Afficher les éléments précédents {{count}}',
      previousLabel_many: 'Afficher les éléments précédents {{count}}',
      previousLabel_other: 'Afficher les éléments précédents {{count}}',
      // v3 plural
      previousLabel: 'Afficher l\'élément précédent {{count}}',
      previousLabel_plural: 'Afficher les éléments précédents {{count}}',
      previousLabel_0: 'Afficher l\'élément précédent {{count}}',
      previousLabel_1: 'Afficher les éléments précédents {{count}}',
      previousLabel_2: 'Afficher les éléments précédents {{count}}'
    },
    embeddedPost: {
      ariaLabel: {
        viewArticle: 'Voir {{title}}'
      }
    },
    filters: {
      ariaLabel: {
        activeFilters: 'Filtres actifs',
        closeFilters: 'Fermer la barre latérale des filtres',
        refine: 'Affiner',
        showMoreFilters: 'Afficher plus de filtres',
        clearFiltersText: 'Effacer tous les filtres'
      },
      button: {
        clearFiltersText: 'Effacer',
        refineText: 'Affiner',
        showMoreFiltersText: 'Plus de filtres',
        closeText: 'Fermer'
      },
      clearAll: 'Tout effacer',
      refineText: 'Affinez vos résultats',
      yourFilters: 'Vos filtres :',
      sr: {
        closeFilters: 'Fermer la barre latérale des filtres'
      }
    },
    listPage: {
      showMoreButtonsText: 'Charger plus'
    },
    liveBlog: {
      errorMessage: 'Désolé, quelque chose a mal tourné lors du chargement de plus d\'éléments, veuillez réessayer.',
      isLiveUpdatedText: 'MISE À JOUR EN DIRECT {{duration}}',
      liveIconTitle: 'en direct',
      liveKickerTitle: 'En direct',
      loadMoreButtonText: 'Charger plus',
      notLiveUpdatedText: 'Mis à jour {{duration}}',
      statusText: 'La couverture en direct de cet événement est maintenant terminée',
      time: {
        // v4 plural
        lessThanOneHour_one: 'il y a {{count}} minute',
        lessThanOneHour_few: 'il y a {{count}} minutes',
        lessThanOneHour_many: 'il y a {{count}} minutes',
        lessThanOneHour_other: 'il y a {{count}} minutes',
        // v3 plural
        lessThanOneHour: 'il y a {{count}} minute',
        lessThanOneHour_plural: 'il y a {{count}} minutes',
        lessThanOneHour_0: 'il y a {{count}} minute',
        lessThanOneHour_1: 'il y a {{count}} minutes',
        lessThanOneHour_2: 'il y a {{count}} minutes',
        lessThanOneMinute: 'il y a moins de 1 minute',
        // v4 plural
        moreThanHour_one: 'il y a {{count}} heure',
        moreThanHour_few: 'il y a {{count}} heures',
        moreThanHour_many: 'il y a {{count}} heures',
        moreThanHour_other: 'il y a {{count}} heures',
        // v3 plural
        moreThanHour: 'il y a {{count}} heure',
        moreThanHour_plural: 'il y a {{count}} heures',
        moreThanHour_0: 'il y a {{count}} heure',
        moreThanHour_1: 'il y a {{count}} heures',
        moreThanHour_2: 'il y a {{count}} heures'
      }
    },
    loginLanding: {
      button: {
        loginText: 'Connectez-vous avec votre email'
      },
      link: {
        createAccountText: 'Créer un compte'
      },
      dividerText: 'OU',
      newHereText: 'Nouveau ici?',
      loginHeaderText: 'Bonjour à nouveau. Vous nous avez manqué, nous sommes heureux que vous soyez de retour.'
    },
    loginForm: {
      emailLabel: 'Email',
      emailPlaceholder: 'Entrez votre email',
      loginFormHeaderText: 'Entrez vos détails pour vous connecter à votre compte',
      button: {
        loginText: 'Se connecter'
      },
      link: {
        forgotPasswordText: 'Mot de passe oublié?'
      }
    },
    mainNav: {
      ariaLabel: {
        main: 'Principal'
      },
      sr: {
        tierThreeBack: 'Retour à',
        tierTwoBack: 'Retour à'
      }
    },
    marketingPreferencesForm: {
      button: {
        saveMyPreferencesText: 'Enregistrer mes préférences'
      },
      checkbox: {
        label: 'Oui, inscrivez-moi'
      },
      heading: 'Souhaitez-vous recevoir des offres de {{brand}} et de son éditeur Immediate Media Company Limited?',
      notification: {
        error: 'Nous n\'avons pas pu enregistrer vos préférences. Veuillez visiter Mon compte et mettre à jour vos paramètres.'
      }
    },
    newsLetterSignUp: {
      input: {
        emailPlaceholder: 'Adresse e-mail'
      }
    },
    post: {
      ariaLabel: {
        calloutButtonEdit: 'Modifier',
        calloutButtonPublish: 'Publier'
      },
      productSpec: {
        collapseButtonText: 'Moins de détails',
        expandButtonText: 'Plus de détails',
        headline: 'Spécifications du produit',
        skip: 'Passer pour voir les spécifications du produit'
      },
      sr: {
        sponsoredHeading: 'Contenu sponsorisé'
      }
    },
    postHeader: {
      button: {
        dealsText: 'Passer pour voir les offres',
        print: 'Imprimer'
      },
      itemCount: {
        // v3 plural
        items_one: 'article',
        items_few: 'articles',
        items_many: 'articles',
        items_other: 'articles',
        // v4 plural
        items: 'article',
        items_plural: 'articles',
        items_0: 'article',
        items_1: 'articles',
        items_2: 'articles'
      },
      ourRatingText: 'Notre évaluation',
      publishDate: 'Publié : {{published}}'
    },
    reaction: {
      ariaLabel: {
        "delete": 'Supprimer'
      },
      button: {
        replyText: 'Répondre',
        reportText: 'Signaler'
      },
      removedText: 'Ceci a été supprimé'
    },
    registrationForm: {
      createText: 'Créer un compte',
      emailPlaceholder: 'Entrez votre email',
      srButton: 'bouton.',
      emailLabel: 'Email'
    },
    registrationLanding: {
      ariaLabel: {
        signUpText: 'Cliquez ici pour vous inscrire avec votre email'
      },
      button: {
        signUpText: 'Inscrivez-vous avec votre email'
      },
      link: {
        loginText: 'Se connecter'
      },
      dividerText: 'OU',
      alreadyRegisteredText: 'Déjà inscrit?',
      registrationHeaderText: 'Créez votre compte {{brand}} et recevez nos newsletters exclusives par email.'
    },
    forgottenPasswordForm: {
      formCopy: 'Entrez votre adresse email enregistrée et nous vous aiderons à réinitialiser votre mot de passe.',
      emailLabel: 'Email',
      emailPlaceholder: 'Entrez votre email',
      resetPasswordButtonText: 'Réinitialiser le mot de passe'
    },
    reviewSummary: {
      heading: 'Ce que nous avons testé'
    },
    roastCalculator: {
      button: {
        resetText: 'Réinitialiser'
      },
      imperialLabel: 'Impérial',
      metricLabel: 'Métrique',
      sr: {
        imperialValueOunces: 'Valeur impériale en onces',
        imperialValuePounds: 'Valeur impériale en livres',
        metricConverterLabel: 'Valeur métrique en {{unit}}',
        metricConverterUnit: 'unité {{converter}}',
        selectMeat: 'Sélectionnez la viande'
      },
      meat: {
        beefMedium: 'Boeuf (moyen)',
        beefRare: 'Boeuf (rare)',
        beefWellDone: 'Boeuf (bien cuit)',
        chicken: 'Poulet',
        duck: 'Canard',
        goose: 'Oie',
        lambMedium: 'Agneau (moyen)',
        lambRare: 'Agneau (rare)',
        lambWellDone: 'Agneau (bien cuit)',
        pork: 'Porc',
        turkey: 'Dinde',
        venisonMedium: 'Venaison (moyen)',
        venisonRare: 'Venaison (rare)',
        venisonWellDone: 'Venaison (bien cuit)'
      }
    },
    searchResults: {
      button: {
        loadPrevious: 'Charger précédent',
        loadNext: 'Charger suivant'
      },
      showingItems: 'Affichage de {{from}} à {{to}} sur {{total}} résultats',
      noResults: 'Désolé, quelque chose a mal tourné lors du chargement des résultats de la recherche, veuillez réessayer.'
    },
    siteFooter: {
      privacyItemLabel: 'Gérer les paramètres de confidentialité',
      privacyItemTitle: 'Gérez vos paramètres de confidentialité et de consentement'
    },
    verificationError: {
      errorWithRetrySignUpCopy: 'Nous avons rencontré un problème lors de la tentative de vérification de votre compte. Essayez de vous inscrire à nouveau ou contactez le support.',
      errorWithResendEmailCopy: 'Désolé pour ça! Essayez de cliquer ci-dessous pour envoyer un nouvel email de vérification.',
      linkExpiredWithResendEmailCopy: 'Le lien que nous vous avons envoyé n\'est plus valide, nous faisons cela pour sécuriser votre compte. Cliquez ci-dessous pour envoyer un nouvel email de vérification.',
      supportEmailSubject: 'J\'ai besoin d\'aide pour vérifier mon compte.'
    },
    weightVolumeConverter: {
      ariaLabel: {
        imperialValue: 'Valeur impériale en {{units}}',
        imperialValueOther: 'Valeur impériale en {{units}}',
        metricUnitText: 'sélection d\'unité métrique',
        metricValueText: 'Valeur métrique'
      },
      sr: {
        imperialValue: 'Valeur impériale en {{units}}',
        imperialValueOther: 'Valeur impériale en {{units}}',
        metricUnitText: 'Unité métrique',
        metricValueText: 'Valeur métrique'
      },
      volumeText: 'Volume',
      weightText: 'Poids'
    }
  },
  templates: {
    searchPage: {
      title: 'Vos résultats de recherche',
      noResults: 'Désolé, nous n\'avons trouvé aucun résultat. Veuillez essayer de mettre à jour votre terme de recherche.',
      error: 'Désolé, il y a eu un problème lors du chargement des résultats de la recherche.',
      sort: 'Trier'
    }
  }
};